import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Filter from "./Filter";
import Table from "./Table";
import { useDispatch, useSelector } from "react-redux";
import {
  ConsumableItemReport,
  GetCustomerReport,
  GetExturnalauditReport,
} from "../../../../../features/admin/report_generator/Slice";
import { GetAll } from "../../../../../features/admin/consumable_item/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";

const Consumable_Item_Report = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);

  const [searchParams, setSearchParams] = useState({
    start_date: "",
    end_date: "",
    status_id: "",
    name: "",
  });
  const consumable_item = useSelector((state) => state?.consumable_item);
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        name: searchParams?.name || "",
        page: page,
        start_date: searchParams.start_date || "",
        end_date: searchParams.end_date || "",
        per_page: consumable_item.per_page,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReportPermission = permissions?.includes(
    FixIDS.consumable_item_report.Report,
  );

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [dispatch, currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      ConsumableItemReport({
        page: 1,
        per_page: consumable_item.per_page,
        start_date: searchParams?.start_date,
        end_date: searchParams?.end_date,
        status_id: searchParams?.status_id?.value,
        name: searchParams?.name,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Consumable Item Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            externalauditdetails={consumable_item}
          />
        )}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Consumable Item Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Consumable_Item_Report;
